// 筛选选项
export const filterPrices = ['1000以下', '1000-1500', '1500-2500', '2500以上'];
export const filterStyles = ['全能', '刻滑', '平花','公园', '大山', '道外','深粉','燕尾'];

// 品牌数据
export const allBrands = [
  {
    brandId: "158",
    brandName: "Adidas"
  },
  {
    brandId: "154",
    brandName: "Nobaday零夏"
  },
  {
    brandId: "132",
    brandName: "K2"
  },
  {
    brandId: "101",
    brandName: "Smokin"
  },
  {
    brandId: "171",
    brandName: "Nike"
  },
  {
    brandId: "84",
    brandName: "Arbor"
  },
  {
    brandId: "77",
    brandName: "Capita"
  },
  {
    brandId: "110",
    brandName: "Lib Tech"
  },
  {
    brandId: "147",
    brandName: "BC Stream"
  },
  {
    brandId: "106",
    brandName: "YES"
  },
  {
    brandId: "92",
    brandName: "Flux"
  },
  {
    brandId: "97",
    brandName: "Nitro"
  },
  {
    brandId: "96",
    brandName: "Never Summer"
  },
  {
    brandId: "137",
    brandName: "Rome"
  },
  {
    brandId: "151",
    brandName: "Lobster"
  },
  {
    brandId: "172",
    brandName: "Roxy"
  },
  {
    brandId: "98",
    brandName: "Northwave"
  },
  {
    brandId: "93",
    brandName: "GNU"
  },
  {
    brandId: "139",
    brandName: "Bent Metal"
  },
  {
    brandId: "156",
    brandName: "Kessler"
  },
  {
    brandId: "157",
    brandName: "Spread"
  },
  {
    brandId: "86",
    brandName: "Burton"
  },
  {
    brandId: "174",
    brandName: "Yonex"
  },
  {
    brandId: "149",
    brandName: "Gray"
  },
  {
    brandId: "181",
    brandName: "Nidecker"
  },
  {
    brandId: "165",
    brandName: "CLEW"
  },
  {
    brandId: "82",
    brandName: "Union"
  },
  {
    brandId: "105",
    brandName: "Vans"
  },
  {
    brandId: "152",
    brandName: "November"
  },
  {
    brandId: "85",
    brandName: "Bataleon"
  },
  {
    brandId: "91",
    brandName: "Flow"
  },
  {
    brandId: "148",
    brandName: "Korua Shapes"
  },
  {
    brandId: "150",
    brandName: "Ogasaka"
  },
  {
    brandId: "94",
    brandName: "Jones"
  },
  {
    brandId: "89",
    brandName: "Deeluxe"
  },
  {
    brandId: "153",
    brandName: "Rice28"
  },
  {
    brandId: "100",
    brandName: "Ride"
  },
  {
    brandId: "102",
    brandName: "SP"
  },
  {
    brandId: "78",
    brandName: "ThirtyTwo"
  },
  {
    brandId: "88",
    brandName: "DC"
  },
  {
    brandId: "123",
    brandName: "Salomon"
  },
  {
    brandId: "90",
    brandName: "Drake"
  },
  {
    brandId: "99",
    brandName: "NOW"
  },
    {
    brandId: "200",
    brandName: "011"
  }
];

// 字母表
export const alphabet = Array.from({ length: 26 }, (_, i) => String.fromCharCode(65 + i));

// GraphQL 端点 - 根据环境自动选择地址
// 开发环境使用 localhost，生产环境使用配置的服务器地址
export const GRAPHQL_ENDPOINT = process.env.NODE_ENV === 'development' 
  ? 'http://localhost:4000/graphql'
  : (process.env.REACT_APP_GRAPHQL_URL || 'https://www.bresnow.com/graphql'); 

// 产品类别常量，方便全局复用和维护
export const categoriesTrans = [
  { value: '1', label: '滑雪板' },
  { value: '2', label: '固定器' },
  { value: '3', label: '雪鞋' }
];

// 产品级别常量
export const levels = ['入门级', '中级', '高级'];

// 产品风格常量
export const styles = ['全能', '全能偏公园', '全能偏大山', '刻滑', '平花','公园', '道具', '大山', '道外','深粉','燕尾','登山'];

export const numberColors = [
  '#FF9800', // 橙色
  '#1E3A8A', // 深蓝色
  '#FFD600', // 黄色
  '#00B8F6', // 天蓝色
  '#8B5CF6', // 紫色
];